export default {
  id: "timeSeriesRevenue",
  name: "",
  description: "",
  report: {
    name: "Daily Revenue",
    chartType: "LINE",
    template: "custom",
    config: {
      dataType: "time_series",
      dataSet: "SaleItem",
      dimensions: [],
      measures: ["SaleItem.revenue"],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: true,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
